import React, { useState } from "react";
import { RiAddBoxFill, RiEdit2Fill } from "react-icons/ri";
import ActionReferralModal from "../modals/ActionRefferalModal";
import { usePatient } from "../../contexts";
import Spinner from "../UI/Spinner";
import TableSkeleton from "./TableSkeleton";

function ReferralTable({ data, fetch, loading, currentPage, itemsPerPage }) {
  const { setPatientInfo } = usePatient();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [referralId, setReferralId] = useState('');
  const [referralInfo, setReferralInfo] = useState('');

  console.log(data);

  const { setPatientId } = usePatient();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setPatientInfo(null);
  };

  const continueUpdate = (id, data) => {
    setPatientInfo(data);
    setReferralInfo(data);
    setReferralId(data?.medId);
    openModal();
  };

  // Sort data by dateAndTimeInitiated in descending order
  const sortedData = [...data].sort((a, b) => new Date(b.dateAndTimeInitiated) - new Date(a.dateAndTimeInitiated));
  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    return (
      <div className="w-100">
        <div className="tabs m-t-10 bold-text"></div>
        <div className="flex flex-col gap-12 m-t-20">
          {loading ? (
            <TableSkeleton />
          ) : sortedData.length === 0 ? (
            "No Records"
          ) : (
            sortedData.map((row) => (
              <div key={row?.id} className="card shadow-sm m-b-20" style={{ borderRadius: '8px', border: '1px solid #e0e0e0', overflow: 'hidden' }}>
                <div className="flex flex-h-between flex-v-center" style={{ padding: '15px', backgroundColor: '#f8f9fa', borderBottom: '1px solid #eee' }}>
                  <h4 className="m-0" style={{ fontSize: '16px', fontWeight: '600', color: '#333' }}>{row?.patient?.firstName} {row?.patient?.lastName}</h4>
                  <span style={{ fontSize: '12px', color: '#666' }}>ID: {row?.patient?.id}</span>
                </div>
                <div style={{ padding: '15px' }}>
                  <div className="m-b-10">
                    <span className="text-uppercase text-muted block m-b-5" style={{ fontSize: '11px', fontWeight: 'bold', color: '#888' }}>LAB WORK REQUESTED</span>
                    {row?.testRequests?.map((request, i) => (
                      <div className="m-b-5" key={i} style={{ fontSize: '14px' }}>{i + 1}. {request?.referredInternalLabService?.name}{request?.isPaid ? " (Paid)" : ""}</div>
                    ))}
                  </div>
                  <div className="flex flex-h-between m-b-10">
                    <div>
                      <span className="text-uppercase text-muted block m-b-5" style={{ fontSize: '11px', fontWeight: 'bold', color: '#888' }}>REFERRED FROM</span>
                      <span style={{ fontSize: '14px' }}>{row?.initiatedHealthCareProvider?.name}</span>
                    </div>
                    <div className="text-right">
                      <span className="text-uppercase text-muted block m-b-5" style={{ fontSize: '11px', fontWeight: 'bold', color: '#888' }}>DOCTOR</span>
                      <span style={{ fontSize: '14px' }}>{row?.doctor?.firstName} {row?.doctor?.lastName}</span>
                    </div>
                  </div>
                  <div className="text-right">
                     <span style={{ fontSize: '12px', color: '#999' }}>{new Date(row?.dateAndTimeInitiated).toLocaleDateString()} {new Date(row?.dateAndTimeInitiated).toLocaleTimeString()}</span>
                  </div>
                </div>
                <div className="flex flex-h-end" style={{ padding: '10px 15px', backgroundColor: '#f8f9fa', borderTop: '1px solid #eee' }}>
                   <RiEdit2Fill
                        onClick={() => continueUpdate(row?.patient?.id, row)}
                        className="pointer"
                        style={{ width: '24px', height: '24px', color: '#3C7E2D' }}
                      />
                </div>
              </div>
            ))
          )}
        </div>
        {isModalOpen && <ActionReferralModal closeModal={closeModal} referralId={referralId} referralInfo={referralInfo} fetch={fetch} />}
      </div>
    );
  }

  return (
    <div className="w-100">
      <div className="tabs m-t-10 bold-text"></div>
      <div className="w-100 none-flex-item m-t-40">
        <table className="bordered-table">
          <thead className="border-top-none">
            <tr className="border-top-none">
              <th className="center-text">Patient's Id</th>
              <th className="center-text">First Name</th>
              <th className="center-text">Last Name</th>
              <th className="center-text">Lab Work Requested</th>
              <th className="center-text">Referred From</th>
              <th className="center-text">Doctor</th>
              <th className="center-text">Date Created</th>
              <th className="center-text">Time Initiated</th>
              <th className="center-text">Action</th>
            </tr>
          </thead>
          {loading ? (
            <TableSkeleton primary={5} secondary={9} />
          ) :
           (sortedData.length === 0 ? "No Records" : <tbody className="white-bg view-det-pane">
              {(Array.isArray(sortedData) && sortedData.map((row, index) => (
                <tr className="pointer hovers" key={row?.id}>
                  <td>{row?.patient?.id}</td>
                  <td>{row?.patient?.firstName}</td>
                  <td>{row?.patient?.lastName}</td>
                  <td>
                    {row?.testRequests?.map((request, i) => (
                      <div className="m-b-5" key={i}>{i + 1}. {request?.referredInternalLabService?.name}{request?.isPaid ? " (Paid)" : ""}</div>
                    ))}
                  </td>
                  <td>{row?.initiatedHealthCareProvider?.name}</td>
                  <td>{row?.doctor?.firstName} {row?.doctor?.lastName}</td>
                  <td>{new Date(row?.dateAndTimeInitiated).toLocaleDateString()}</td>
                  <td>{new Date(row?.dateAndTimeInitiated).toLocaleTimeString()}</td>
                  <td>
                    <span style={{ color: '#3C7E2D' }} className="flex flex-h-center">
                      <RiEdit2Fill
                        onClick={() => continueUpdate(row?.patient?.id, row)}
                        className="pointer"
                        style={{ width: '24px', height: '24px' }}
                      />
                    </span>
                  </td>
                </tr>
              )))}
            </tbody>)
          }
        </table>
      </div>
      {
        isModalOpen &&
        <ActionReferralModal
          closeModal={closeModal}
          referralId={referralId}
          referralInfo={referralInfo}
          fetch={fetch}
        />
      }
    </div>
  );
}

export default ReferralTable;
